import React, { createContext, useContext, useState, useEffect } from 'react';
import { adminLogin } from '../services/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    const user  = localStorage.getItem('admin_user');
    if (token && user) {
      try { setAdmin(JSON.parse(user)); } catch {}
    }
    setLoading(false);
  }, []);

  // credentials = { username, password }
  const login = async (credentials) => {
    const res = await adminLogin(credentials);
    const payload = res.data?.data || res.data;   // handles both { data: {...} } and flat
    const { token, username, role } = payload;
    localStorage.setItem('admin_token', token);
    localStorage.setItem('admin_user', JSON.stringify({ username, role }));
    setAdmin({ username, role });
    return res;
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
